import React, { useState, useCallback, useEffect } from "react";
import List from "../codeList";
import Filter from "../codeFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import { useNavigate } from "react-router-dom";
import * as ArticleService from "../../../../services/ArticleService";
import * as LocationService from "../../../../services/LocationService";
import * as ViveroService from "../../../../services/ViveroService";
import * as BatchService from "../../../../services/BatchService";
import * as VarietyService from "../../../../services/VarietyService";
import * as SectorService from "../../../../services/SectorService";
import * as GeneralServices from "../../../../services/GeneralServices";
import { SET_FILTER_CODE } from "../../../../constants";
import { getFilterCodeSelector } from "../../../../store/selectors/navSelector";
import { useSelector } from "react-redux";

const queryClient = new QueryClient();

const CodeFilterListContainer = (props) => {
  const { t } = useTranslation();
  // const [filters, setFilters] = useState(undefined);
  const navigate = useNavigate();
  const [viveros, setViveros] = useState([]);
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.code.title") },
  ];
  const filters = useSelector(getFilterCodeSelector);

  const loadViveros = useCallback(async () => {
    const resultViveros = await ViveroService.getAllViveros();
    if (resultViveros) {
      setViveros(resultViveros);
    }
  }, []);

  useEffect(() => {
    loadViveros();
  }, [loadViveros]);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    // setFilters(undefined);
    GeneralServices.setFilter(undefined, SET_FILTER_CODE);
  };

  const goToForm = async () => {
    navigate(PATHS.CREATE_CODE);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    // setFilters(newFilter);s
    GeneralServices.setFilter(newFilter, SET_FILTER_CODE);
  };
  const handlerFilterArticle = async (value) => {
    let filter = {
      filters: {
        code: value,
      },
    };

    let result = await ArticleService.getAllArticles(filter);
    if (result && result.length === 0) {
      if (filters?.articleUuid) {
        filter = {
          filters: {
            uuid: filters.articleUuid,
          },
        };
        result = await ArticleService.getAllArticles(filter);
      }
    }
    return result;
  };

  const handlerFilterLocation = async (value) => {
    let filter = {
      filters: {
        name: value,
      },
    };

    let result = await LocationService.getAllLocations(filter);
    if (result && result.length === 0) {
      if (filters?.locationUuid) {
        filter = {
          filters: {
            uuid: filters.locationUuid,
          },
        };
        result = await LocationService.getAllLocations(filter);
      }
    }
    return result;
  };

  const handlerFilterBatch = async (value) => {
    let filter = {
      filters: {
        code: value,
      },
    };
    let result = await BatchService.getAllBatches(filter);
    if (result && result.length === 0) {
      if (filters?.batch) {
        filter = {
          filters: {
            uuid: filters.batch,
          },
        };
        result = await BatchService.getAllBatches(filter);
      }
    }
    return result;
  };

  const handlerFilterVariety = async (value) => {
    let filter = {
      filters: {
        name: value,
      },
    };

    let result = await VarietyService.getAllVarieties(filter);
    if (result && result.length === 0) {
      if (filters?.varietyUuid) {
        filter = {
          filters: {
            uuid: filters.varietyUuid,
          },
        };
        result = await VarietyService.getAllVarieties(filter);
      }
    }
    return result;
  };

  const handlerFilterSector = async (value) => {
    let filter = {
      filters: {
        name: value,
      },
    };

    let result = await SectorService.getAllSectors(filter);
    if (result && result.length === 0) {
      if (filters?.sectorUuid) {
        filter = {
          filters: {
            uuid: filters.sectorUuid,
          },
        };
        result = await SectorService.getAllSectors(filter);
      }
    }
    return result;
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.code.title")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            onFilterArticle={handlerFilterArticle}
            onFilterLocation={handlerFilterLocation}
            onFilterBatch={handlerFilterBatch}
            onFilterVariety={handlerFilterVariety}
            onFilterSector={handlerFilterSector}
            viveros={viveros}
            initialValues={filters}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          <button
            className="btn btn-secondary btn-md"
            onClick={() => goToForm()}
          >
            {t("forms.code.buttons.new")}
          </button>
        </div>
      </div>
    </>
  );
};

CodeFilterListContainer.propTypes = {};

export default CodeFilterListContainer;
